var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItem4A(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 750 289",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    d: "m619.12 168.34-74.302 37.617 0.15544 34.197 48.654 4.3524c11.192-6.684 18.809-12.591 23.006-17.72 8.8602-5.7514 27.669-20.208 56.581-43.213 28.912-23.161 47.721-37.617 56.581-43.369-23.783-0.93266-107.41-3.8861-250.73-8.8602-143.32-5.1296-226.95-8.083-250.73-9.0157l-39.638 9.7929-148.6 75.234 51.918 1.8653 39.638-9.7929c8.3939-4.197 24.094-12.28 47.41-23.938 23.316-11.814 37.773-19.119 43.369-21.917l85.027 3.1089-100.42 62.954 55.804 1.8653c12.435-6.2177 24.715-12.435 37.151-18.653 30.311-16.632 59.379-32.643 87.048-48.032 32.954-6.8395 58.757-4.3524 77.566 7.6167l-1.2435-0.15544-86.271 66.219 51.296 2.6425c12.902-6.3732 19.43-11.036 19.586-14.145 8.083-4.5078 23.161-13.368 45.234-27.047 22.073-13.524 35.752-21.917 41.192-25.026l84.716 3.4197z",
    fill: "gray",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.904 210.93v-37.462l-55.804-3.8861v37.617l55.804 3.7306z",
    fill: "#ccc",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.904 210.93-55.804-3.7306v-37.617l55.804 3.8861v37.462z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.904 173.47v37.617c6.684-6.684 13.524-13.213 20.363-19.586v-37.617c-6.8395 6.5286-13.524 13.057-20.363 19.586z",
    fill: "#404040",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.904 173.47c6.684-6.5286 13.524-13.057 20.363-19.586v37.617c-6.8395 6.5286-13.679 13.057-20.363 19.586v-37.617z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.32 222.59v-37.462l-55.804-3.8861v37.617l55.804 3.7306z",
    fill: "#ccc",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.32 222.74-55.804-3.7306v-37.617l55.804 3.8861v37.462z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.32 185.13v37.617c6.684-6.684 13.524-13.213 20.363-19.586v-37.617c-6.8395 6.5286-13.524 13.057-20.363 19.586z",
    fill: "#404040",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.32 185.13c6.684-6.5286 13.524-13.057 20.363-19.586v37.617c-6.8395 6.5286-13.679 13.057-20.363 19.586v-37.617z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m235.18 145.64-27.669-1.8653v37.617l27.669 1.8653v-37.617z",
    fill: "#ccc",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m235.34 145.64v37.462l-27.669-1.8653v-37.617l27.669 2.0208z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.32 147.51-27.98-1.8653v37.617l27.98 1.8653v-37.617z",
    fill: "#ccc",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.32 147.66v37.617l-27.98-1.8653v-37.773l27.98 2.0208z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.32 147.35v37.617c6.684-6.684 13.524-13.213 20.363-19.586v-37.617c-6.8395 6.5286-13.524 13.057-20.363 19.586z",
    fill: "#404040",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.32 147.51c6.684-6.5286 13.524-13.057 20.363-19.586v37.617c-6.8395 6.5286-13.679 13.057-20.363 19.586v-37.617z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m430.57 234.25v-37.462l-55.804-3.8861v37.617l55.804 3.7306z",
    fill: "#ccc",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m430.57 234.4-55.804-3.7306v-37.617l55.804 3.8861v37.462z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m430.57 196.63v37.617c6.684-6.684 13.524-13.213 20.363-19.586v-37.617c-6.8395 6.5286-13.679 13.057-20.363 19.586z",
    fill: "#404040",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m430.57 196.63c6.684-6.5286 13.524-13.057 20.363-19.586v37.617c-6.8395 6.5286-13.679 13.057-20.363 19.586v-37.617z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m402.75 157.15-27.98-1.8653v37.617l27.98 1.8653v-37.617z",
    fill: "#ccc",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m402.75 157.15v37.462l-27.98-1.8653v-37.617l27.98 2.0208z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m430.57 159.01v37.462c6.684-6.5286 13.524-13.057 20.363-19.586v-37.462c-6.8395 6.5286-13.679 13.057-20.363 19.586z",
    fill: "#404040",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m430.57 159.17c6.684-6.5286 13.524-13.057 20.363-19.586v37.462c-6.8395 6.5286-13.679 13.057-20.363 19.586v-37.462z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m430.57 196.63v-37.462l-27.98-1.8653v37.617l27.98 1.7099z",
    fill: "#ccc",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m430.57 196.63-27.98-1.8653v-37.617l27.98 1.8653v37.617z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m597.52 245.9v-37.462l-55.493-3.8861v37.617l55.493 3.7306z",
    fill: "#ccc",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m597.67 246.06-55.493-3.7306v-37.617l55.493 3.8861v37.462z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m597.52 208.29v37.617c6.684-6.684 13.524-13.213 20.363-19.586v-37.617c-6.8395 6.5286-13.679 13.057-20.363 19.586z",
    fill: "#404040",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m597.52 208.29c6.684-6.5286 13.524-13.057 20.363-19.586v37.617c-6.8395 6.5286-13.679 13.057-20.363 19.586v-37.617z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m68.08 171.45v-37.462l-27.98-1.8653v37.617l27.98 1.7099z",
    fill: "#ccc",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m68.08 171.6-27.98-1.8653v-37.617l27.98 1.8653v37.617z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.904 135.7v37.462c6.684-6.5286 13.524-13.057 20.363-19.586v-37.462c-6.8395 6.5286-13.524 13.057-20.363 19.586z",
    fill: "#404040",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.904 135.85c6.684-6.5286 13.524-13.057 20.363-19.586v37.462c-6.8395 6.5286-13.679 13.057-20.363 19.586v-37.462z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.904 173.47v-37.462l-27.98-1.8653v37.617l27.98 1.7099z",
    fill: "#ccc",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.904 173.47-27.98-1.8653v-37.617l27.98 1.8653v37.617z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.904 135.85v-37.462l-55.804-3.8861v37.617l55.804 3.7306z",
    fill: "#ccc",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.904 135.85-55.804-3.7306v-37.617l55.804 3.8861v37.462z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.904 98.234v37.617c6.684-6.684 13.524-13.213 20.363-19.586v-37.617c-6.8395 6.5286-13.524 13.057-20.363 19.586z",
    fill: "#404040",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.904 98.234c6.684-6.5286 13.524-13.057 20.363-19.586v37.617c-6.8395 6.5286-13.679 13.057-20.363 19.586v-37.617z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m68.08 96.368v-37.462l-27.98-1.8653v37.617l27.98 1.7099z",
    fill: "#ccc",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m68.08 96.368-27.98-1.8653v-37.617l27.98 1.8653v37.617z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.1 56.886 27.98 1.8653c6.684-6.5286 13.524-13.057 20.208-19.586-9.3266-0.62177-18.498-1.399-27.824-1.8653-6.8395 6.5286-13.524 13.057-20.363 19.586z",
    fill: "gray",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.1 56.886c6.684-6.5286 13.524-13.057 20.363-19.586 9.3266 0.62177 18.498 1.2435 27.824 1.8653-6.684 6.5286-13.524 13.057-20.208 19.586l-27.98-1.8653z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m123.73 100.1 10.726-36.84-66.53-4.6633v37.617l55.804 3.8861z",
    fill: "#ccc",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m123.73 100.1-55.804-3.7306v-37.617l66.53 4.6633-10.726 36.685z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.924 58.751c22.228 1.5544 44.301 3.1089 66.53 4.6633 6.8395-6.5286 13.679-13.057 20.363-19.586-22.228-1.5544-44.301-3.1089-66.53-4.6633-6.8395 6.5286-13.524 13.057-20.363 19.586z",
    fill: "gray",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m68.08 58.751c6.684-6.5286 13.524-13.057 20.363-19.586 22.228 1.5544 44.301 3.1089 66.53 4.6633-6.684 6.5286-13.524 13.057-20.363 19.586-22.228-1.5544-44.457-3.1089-66.53-4.6633z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m134.61 63.414c11.503 0.77721 22.85 1.5544 34.197 2.3316 6.684-6.5286 13.524-13.057 20.363-19.586-11.503-0.77721-22.85-1.5544-34.197-2.3316-6.8395 6.5286-13.679 13.057-20.363 19.586z",
    fill: "gray",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m134.61 63.414c6.684-6.5286 13.524-13.057 20.363-19.586 11.347 0.77721 22.85 1.5544 34.197 2.3316-6.8395 6.5286-13.679 13.057-20.363 19.586-11.347-0.77721-22.85-1.5544-34.197-2.3316z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m179.53 103.98-10.726-38.394-34.197-2.3316-10.726 36.84 55.649 3.8861z",
    fill: "#ccc",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m179.53 104.14-55.804-3.8861 10.726-36.84 34.197 2.3316 10.881 38.394z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.32 109.89v37.617c6.684-6.684 13.524-13.213 20.363-19.586v-37.617c-6.8395 6.5286-13.524 13.057-20.363 19.586z",
    fill: "#404040",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.32 109.89c6.684-6.5286 13.524-13.057 20.363-19.586v37.617c-6.8395 6.5286-13.679 13.057-20.363 19.586v-37.617z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.32 147.51v-37.462l-55.804-3.8861v37.617l55.804 3.7306z",
    fill: "#ccc",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.32 147.51-55.804-3.7306v-37.617l55.804 3.8861v37.462z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m168.81 65.746c22.228 1.5544 44.301 3.1089 66.53 4.6633 6.8395-6.5286 13.679-13.057 20.363-19.586-22.228-1.5544-44.301-3.1089-66.53-4.6633-6.8395 6.5286-13.524 13.057-20.363 19.586z",
    fill: "gray",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m168.81 65.901c6.684-6.5286 13.524-13.057 20.363-19.586 22.228 1.5544 44.301 3.1089 66.53 4.6633-6.684 6.5286-13.524 13.057-20.363 19.586-22.228-1.7099-44.301-3.1089-66.53-4.6633z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m235.34 108.03v-37.617l-66.53-4.6633 10.726 38.394 55.804 3.8861z",
    fill: "#ccc",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m235.34 108.03-55.804-3.8861-10.726-38.394 66.53 4.6633v37.617z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m235.34 70.409c18.653 1.2435 37.151 2.6425 55.804 3.8861 6.8395-6.5286 13.679-13.057 20.363-19.586-18.653-1.2435-37.151-2.6425-55.804-3.8861-6.8395 6.5286-13.679 13.057-20.363 19.586z",
    fill: "gray",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m235.34 70.409c6.684-6.5286 13.524-13.057 20.363-19.586 18.498 1.2435 37.151 2.6425 55.804 3.8861-6.684 6.5286-13.524 13.057-20.363 19.586-18.653-1.2435-37.151-2.4871-55.804-3.8861z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m290.98 74.295-55.804-3.8861v37.617l26.425 1.8653c9.1711-4.0415 18.964-6.9949 29.223-8.5494 2.9534-0.46633 6.0623-0.77721 9.1711-1.0881l-9.0157-25.959z",
    fill: "#ccc",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m291.14 74.295 9.1711 25.959c-3.1089 0.15544-6.0623 0.62177-9.1711 1.0881-10.259 1.7099-20.052 4.5078-29.223 8.5494l-26.425-1.8653v-37.617l55.649 3.8861z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m291.14 74.295 9.1711 25.959c6.0623-0.46633 12.435-0.46633 18.809-0.15544 6.3732 0.46633 12.591 1.399 18.809 2.6425l9.0157-24.715-55.804-3.7306z",
    fill: "#ccc",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m291.14 74.295 55.804 3.8861-9.0157 24.715c-6.2177-1.2435-12.435-2.1762-18.809-2.6425s-12.746-0.31089-18.809 0.15544l-9.1711-26.114z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m291.14 74.295c18.653 1.2435 37.151 2.6425 55.804 3.8861 6.8395-6.5286 13.679-13.057 20.363-19.586-18.653-1.2435-37.151-2.6425-55.804-3.8861-6.8395 6.5286-13.679 13.057-20.363 19.586z",
    fill: "gray",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m291.14 74.295c6.684-6.5286 13.524-13.057 20.363-19.586 18.498 1.2435 37.151 2.6425 55.804 3.8861-6.684 6.5286-13.524 13.057-20.363 19.586-18.653-1.2435-37.151-2.4871-55.804-3.8861z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m430.57 159.01v-37.462l-55.804-3.8861v37.617l55.804 3.7306z",
    fill: "#ccc",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m430.57 159.01-55.804-3.7306v-37.617l55.804 3.8861v37.462z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m430.57 121.55v37.617c6.684-6.684 13.524-13.213 20.363-19.586v-37.617c-6.8395 6.5286-13.679 13.057-20.363 19.586z",
    fill: "#404040",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m430.57 121.55c6.684-6.5286 13.524-13.057 20.363-19.586v37.617c-6.8395 6.5286-13.679 13.057-20.363 19.586v-37.617z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m346.94 78.181c18.653 1.2435 37.151 2.6425 55.804 3.8861 6.8395-6.5286 13.679-13.057 20.363-19.586-18.653-1.2435-37.151-2.6425-55.804-3.8861-6.8395 6.5286-13.679 13.057-20.363 19.586z",
    fill: "gray",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m346.94 78.181c6.684-6.5286 13.524-13.057 20.363-19.586 18.498 1.2435 37.151 2.6425 55.804 3.8861-6.684 6.5286-13.524 13.057-20.363 19.586-18.653-1.2435-37.151-2.4871-55.804-3.8861z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m346.79 78.181-9.1711 24.715c3.1089 0.62177 6.0623 1.399 9.1711 2.1762 10.259 3.1089 20.052 7.3058 29.223 12.591l26.425 1.8653v-37.462l-55.649-3.8861z",
    fill: "#ccc",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m346.94 78.181 55.804 3.8861v37.462l-26.425-1.8653c-9.1711-5.2851-18.964-9.482-29.223-12.591-2.9534-0.77721-6.0623-1.5544-9.1711-2.1762l9.0157-24.715z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m402.59 81.912c18.653 1.2435 37.151 2.6425 55.804 3.8861 6.8395-6.5286 13.679-13.057 20.363-19.586-18.653-1.2435-37.151-2.6425-55.804-3.8861-6.8395 6.5286-13.524 13.057-20.363 19.586z",
    fill: "gray",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m402.59 81.912c6.684-6.5286 13.524-13.057 20.363-19.586 18.498 1.2435 37.151 2.6425 55.804 3.8861-6.684 6.5286-13.524 13.057-20.363 19.586-18.653-1.2435-37.151-2.6425-55.804-3.8861z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m458.4 123.42v-37.462l-55.804-3.8861v37.617l55.804 3.7306z",
    fill: "#ccc",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m458.4 123.42-55.804-3.7306v-37.773l55.804 3.8861v37.617z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m570 168.8-27.98-1.8653v37.617l27.98 1.8653v-37.617z",
    fill: "#ccc",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m570 168.8v37.462l-27.98-1.8653v-37.617l27.98 2.0208z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m597.52 170.67v37.617c6.684-6.684 13.524-13.213 20.363-19.586v-37.617c-6.8395 6.5286-13.679 13.057-20.363 19.586z",
    fill: "#404040",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m597.52 170.83c6.684-6.5286 13.524-13.057 20.363-19.586v37.617c-6.8395 6.5286-13.679 13.057-20.363 19.586v-37.617z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m597.52 208.29v-37.462l-27.669-1.8653v37.617l27.669 1.7099z",
    fill: "#ccc",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m597.52 208.29-27.669-1.8653v-37.617l27.669 1.8653v37.617z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m597.52 170.51v-37.462l-55.493-3.8861v37.617l55.493 3.7306z",
    fill: "#ccc",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m597.67 170.51-55.493-3.7306v-37.617l55.493 3.8861v37.462z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m597.52 133.05v37.617c6.684-6.684 13.524-13.213 20.363-19.586v-37.617c-6.8395 6.5286-13.679 13.057-20.363 19.586z",
    fill: "#404040",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m597.52 133.05c6.684-6.5286 13.524-13.057 20.363-19.586v37.617c-6.8395 6.5286-13.679 13.057-20.363 19.586v-37.617z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m514.2 127.3v-37.617l-55.804-3.8861v37.617l55.804 3.8861z",
    fill: "#ccc",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m514.2 127.3-55.804-3.7306v-37.617l55.804 3.8861v37.462z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m458.4 85.798c18.653 1.2435 37.151 2.6425 55.804 3.8861 6.8395-6.5286 13.679-13.057 20.363-19.586-18.653-1.2435-37.151-2.6425-55.804-3.8861-6.8395 6.5286-13.524 13.057-20.363 19.586z",
    fill: "gray",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m458.55 85.798c6.684-6.5286 13.524-13.057 20.363-19.586 18.498 1.2435 37.151 2.6425 55.804 3.8861-6.684 6.5286-13.524 13.057-20.363 19.586-18.653-1.2435-37.306-2.6425-55.804-3.8861z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m569.85 131.19v-37.462l-55.804-3.8861v37.617l55.804 3.7306z",
    fill: "#ccc",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m570 131.19-55.804-3.7306v-37.773l55.804 3.8861v37.617z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m514.2 89.684c18.653 1.2435 37.151 2.6425 55.804 3.8861 6.8395-6.5286 13.679-13.057 20.363-19.586-18.653-1.2435-37.151-2.6425-55.804-3.8861-6.8395 6.5286-13.679 13.057-20.363 19.586z",
    fill: "gray",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m514.2 89.684c6.684-6.5286 13.524-13.057 20.363-19.586 18.498 1.2435 37.151 2.6425 55.804 3.8861-6.684 6.5286-13.524 13.057-20.363 19.586-18.653-1.2435-37.151-2.6425-55.804-3.8861z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m597.52 133.05v-37.462l-27.669-1.8653v37.617l27.669 1.7099z",
    fill: "#ccc",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m597.52 133.05-27.669-1.8653v-37.617l27.669 1.8653v37.617z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m569.85 93.57c9.1711 0.62177 18.342 1.2435 27.669 1.8653 6.684-6.5286 13.524-13.057 20.363-19.586-9.1711-0.62177-18.342-1.399-27.669-1.8653-6.8395 6.5286-13.679 13.057-20.363 19.586z",
    fill: "gray",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m570 93.57c6.684-6.5286 13.524-13.057 20.363-19.586 9.1711 0.62177 18.342 1.2435 27.669 1.8653-6.8395 6.5286-13.679 13.057-20.363 19.586-9.3266-0.62177-18.498-1.2435-27.669-1.8653z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m597.52 95.436v37.617c6.684-6.684 13.524-13.213 20.363-19.586v-37.617c-6.8395 6.5286-13.679 13.057-20.363 19.586z",
    fill: "#404040",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m597.52 95.436c6.684-6.5286 13.524-13.057 20.363-19.586v37.617c-6.8395 6.5286-13.679 13.057-20.363 19.586v-37.617z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m196.48 178.6c-3.7306-3.7306-8.083-5.5959-13.368-5.5959s-9.7929 1.8653-13.524 5.5959-5.5959 8.2385-5.5959 13.524 1.8653 9.7929 5.5959 13.524 8.2385 5.5959 13.524 5.5959 9.6375-1.8653 13.368-5.5959 5.5959-8.2385 5.5959-13.524-1.8653-9.7929-5.5959-13.524z",
    fill: "#369",
    fillOpacity: 0.502,
    stroke: "null"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.5515 0 0 1.5544 233.59 185.27)",
    x: -36.47815,
    y: 9.27491,
    fill: "#fff",
    fontFamily: "'ArialMT'",
    fontSize: "11.482px",
    stroke: "null"
  }, "1"), /*#__PURE__*/React.createElement("path", {
    d: "m364.2 178.6c-3.7306-3.7306-8.083-5.5959-13.368-5.5959s-9.7929 1.8653-13.524 5.5959-5.5959 8.2385-5.5959 13.524 1.8653 9.7929 5.5959 13.524 8.2385 5.5959 13.524 5.5959 9.6375-1.8653 13.368-5.5959 5.5959-8.2385 5.5959-13.524-1.8653-9.7929-5.5959-13.524z",
    fill: "#369",
    fillOpacity: 0.502,
    stroke: "null"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.5515 0 0 1.5544 401.31 185.27)",
    x: -36.47815,
    y: 9.27491,
    fill: "#fff",
    fontFamily: "'ArialMT'",
    fontSize: "11.482px",
    stroke: "null"
  }, "2"), /*#__PURE__*/React.createElement("path", {
    d: "m529.9 178.6c-3.7306-3.7306-8.083-5.5959-13.368-5.5959s-9.7929 1.8653-13.524 5.5959-5.5959 8.2385-5.5959 13.524 1.8653 9.7929 5.5959 13.524 8.2385 5.5959 13.524 5.5959 9.6375-1.8653 13.368-5.5959 5.5959-8.2385 5.5959-13.524-1.8653-9.7929-5.5959-13.524z",
    fill: "#369",
    fillOpacity: 0.502,
    stroke: "null"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.5515 0 0 1.5544 567.01 185.27)",
    x: -36.47815,
    y: 9.27491,
    fill: "#fff",
    fontFamily: "'ArialMT'",
    fontSize: "11.482px",
    stroke: "null"
  }, "3"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem4A);
export default __webpack_public_path__ + "static/media/item4a.184fe3a58c86127872d9551ca543660f.svg";
export { ForwardRef as ReactComponent };